import { render, staticRenderFns } from "./Contabilidad_Resumen.vue?vue&type=template&id=2d3bcde3"
import script from "./Contabilidad_Resumen.vue?vue&type=script&lang=js"
export * from "./Contabilidad_Resumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports